import { z } from 'zod';
// Phase 17 (change-list 1.2) — care-professional résumé.
//
// Same presigned-PUT pattern as the profile photo (profile-photo.schema.ts):
// the client asks for a short-TTL signed URL, PUTs the file directly to object
// storage, then confirms with the key. Confirm re-validates the key prefix and
// HEADs the object before recording it.
//
// Visibility: caregiver + operator ONLY. The résumé is a vetting aid and is
// NEVER exposed to buyers.
/** Accepted résumé content types — PDF / DOC / DOCX. */
export const ResumeContentTypeSchema = z.enum([
    'application/pdf',
    'application/msword', // .doc
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
]);
/** 10 MB cap. */
export const RESUME_MAX_BYTES = 10_485_760;
export const CaregiverResumeUploadUrlRequestSchema = z.object({
    contentType: ResumeContentTypeSchema,
    contentLength: z.number().int().positive().max(RESUME_MAX_BYTES),
    /** Original filename — stored so the operator sees what the caregiver
     *  actually uploaded (e.g. "jane-doe-psw-resume.pdf"). */
    filename: z.string().trim().min(1).max(255),
});
export const CaregiverResumeUploadUrlResponseSchema = z.object({
    /** Presigned PUT URL — client uploads the file directly. */
    uploadUrl: z.string().url(),
    /** Object-storage key to hand back on confirm. */
    key: z.string().min(1),
});
export const CaregiverResumeConfirmRequestSchema = z.object({
    key: z.string().min(1),
    filename: z.string().trim().min(1).max(255),
});
/** Current résumé — `url` is a short-lived signed download URL, or null when
 *  none is on file. */
export const CaregiverResumeResponseSchema = z.object({
    url: z.string().url().nullable(),
    filename: z.string().nullable(),
    updatedAt: z.string().nullable(),
});
//# sourceMappingURL=resume.schema.js.map